import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Roles } from '../../../../constants/roles';
import { useInvestorDetails } from '../../../../context/investorDetailContext';
import { InvestorService } from '../../../../pages/investor/investorService';
import { getUser } from '../../../../services/authService';
import InvestorFooter from '../../../../pages/investor/components/footer';
import { MobileSideBar } from './components/mobileSidebar';
import DashboardNavbar from './components/navbar/index';
import { SubNavbar } from './components/subNavbar';

const RootStyle = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	minHeight: '100%',
	overflow: 'clip',
});

const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'clip',
	minHeight: '100%',
	paddingTop: theme.spacing(3),
	paddingBottom: theme.spacing(1),
	paddingLeft: theme.spacing(1),
	paddingRight: theme.spacing(1),
	backgroundColor: '#ffffff',
	[theme.breakpoints.up('md')]: {
		paddingTop: theme.spacing(0),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingBottom: theme.spacing(0),
		paddingLeft: '72px',
		paddingRight: '72px',
	},
}));

const InvestorLayout = () => {
	const investorService = new InvestorService();
	const { setInvestorDetails } = useInvestorDetails();
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		getInvestorDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getInvestorDetails = () => {
		if (getUser()?.role === Roles.Investor) {
			setLoading(true);
			investorService.getInvestor().then(resp => {
				setInvestorDetails(resp.data);
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			}).catch(err => { setLoading(false); });
		}
	};

	return (
		<RootStyle>
			<Box>
				<DashboardNavbar onOpenSidebar={() => setOpen(true)} />
				<SubNavbar></SubNavbar>
				<MobileSideBar
					isOpenSidebar={open}
					onCloseSidebar={() => setOpen(false)}></MobileSideBar>
			</Box>
			<MainStyle className="md:!pt-0">
				<Box className="w-full py-3 sm:py-0 md:py-3 lg:py-3 md:mt-[132px] mt-[55px]">
					{loading ? <Box className='flex h-[80vh] w-full items-center justify-center'>
						<CircularProgress />
					</Box> : <Outlet />}
				</Box>
			</MainStyle>
			<InvestorFooter />
		</RootStyle>
	);
};
export default InvestorLayout;
